module.exports = __webpack_public_path__ + "static/media/joget.01837a27.svg";